import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' }) <PropsType>`
    height: auto;
`;

const CalendarIcon = ({className}: PropsType): React.ReactElement => (
    <SvgWrapper width={24} height={24} fill='#fff' className={className} viewBox='0 0 24 24' xmlSpace='preserve'>
        <path fill='#fill' d='M20.278 3.057h-3.381v-.79a.917.917 0 10-1.83 0v.79H8.32v-.79a.917.917 0 10-1.83 0v.79H3.11c-1.136 0-2.057.92-2.057 2.056v14.869c0 1.135.921 2.056 2.057 2.056h17.168c1.136 0 2.056-.92 2.056-2.056V5.113c0-1.136-.92-2.056-2.056-2.056zM3.11 4.874h3.38v.823a.917.917 0 001.831 0v-.823h6.746v.823a.917.917 0 101.83 0v-.823h3.38c.126 0 .227.102.227.227V7.98H2.884V5.113a.226.226 0 01.226-.239zm17.168 15.334H3.11a.226.226 0 01-.226-.226V9.822h17.62v10.16a.226.226 0 01-.226.226z' />
        <path fill='#fill' d='M12.266 12.31h-1.144a.917.917 0 100 1.831h1.144a.917.917 0 100-1.83zm4.981 0h-1.144a.917.917 0 100 1.831h1.144a.917.917 0 100-1.83zm-9.962 0H6.14a.917.917 0 100 1.831h1.144a.917.917 0 100-1.83zm4.981 3.452h-1.144a.917.917 0 100 1.83h1.144a.917.917 0 100-1.83zm4.981 0h-1.144a.917.917 0 100 1.83h1.144a.917.917 0 100-1.83zm-9.962 0H6.14a.917.917 0 100 1.83h1.144a.917.917 0 100-1.83z' />
    </SvgWrapper>
);

export default CalendarIcon;
